import React, { useMemo } from 'react';

export default function SmartIndex({ incidents = [] }) {
  const likelyDuplicates = useMemo(
    () => incidents.filter(i => i.duplicateStatus && i.duplicateStatus !== 'none').slice(0, 20),
    [incidents]
  );

  return (
    <div style={{padding:'1rem'}}>
      <h2>Smart Index</h2>

      <section style={{marginTop:16}}>
        <h3>Search</h3>
        <input placeholder="Search title/notes…" style={{padding:8, width:'100%', maxWidth:420}} />
      </section>

      <section style={{marginTop:16}}>
        <h3>Likely Duplicates</h3>
        <ul>
          {likelyDuplicates.map(i => (
            <li key={i.id}>
              <strong>{i.title}</strong> — #{i.id || i.code} ({i.duplicateStatus})
            </li>
          ))}
          {likelyDuplicates.length === 0 && <li>No duplicates detected.</li>}
        </ul>
      </section>

      <section style={{marginTop:16}}>
        <h3>Related Incidents (sample)</h3>
        <div style={{color:'#6b7280'}}>Select an incident to see similar items (coming soon).</div>
      </section>
    </div>
  );
}
